import React from "react";
import { Spinner, Stack, Text } from "@bookingcom/bui-react";
import { Breakdown } from "./Breakdown/index.js";
import { Installments, Atol, Disclaimers } from "./banners/index.js";
import { useUnifiedPriceBreakdownFlightCardPriceController } from "./useUnifiedPriceBreakdown.FlightCardPrice.controller.js";
export function UnifiedPriceBreakdownFlightCardPrice(props) {
    const { isHungaryDepartingRyanAir, disclaimers, isFlightDetailsLoading, unifiedPriceBreakdown, expandedByDefault, flightDetailsLoadingText, addedItems } = useUnifiedPriceBreakdownFlightCardPriceController(props);
    if (!unifiedPriceBreakdown) {
        return null;
    }
    return (React.createElement(Stack, { gap: 4 },
        isFlightDetailsLoading ? (React.createElement(React.Fragment, null,
            React.createElement(Stack, { direction: "row" },
                React.createElement(Spinner, { size: "small" }),
                React.createElement(Text, null, flightDetailsLoadingText)),
            React.createElement(Breakdown, { addedItems: [], items: [], footerSections: {}, isHungaryDepartingRyanAir: isHungaryDepartingRyanAir, price: unifiedPriceBreakdown.price }))) : (React.createElement(React.Fragment, null,
            React.createElement(Breakdown, { ...unifiedPriceBreakdown, isHungaryDepartingRyanAir: isHungaryDepartingRyanAir, expandedByDefault: expandedByDefault, addedItems: addedItems }),
            React.createElement(Disclaimers, { disclaimers: disclaimers }))),
        React.createElement(Atol, null),
        React.createElement(Installments, null)));
}
